import React, { memo, forwardRef } from "react";
const SvgAlphabetN = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M11.58 12.33c0-.267.04-.48.12-.64.093-.173.2-.3.32-.38a.915.915 0 01.36-.18c.133-.04.247-.06.34-.06.093 0 .2.02.32.06.133.027.26.087.38.18.12.08.22.207.3.38.093.16.14.373.14.64v.46h.04c.213-.48.58-.9 1.1-1.26.533-.373 1.16-.56 1.88-.56.627 0 1.16.113 1.6.34.453.213.82.5 1.1.86.293.36.507.773.64 1.24.133.467.2.947.2 1.44v4.84c0 .28-.047.513-.14.7a.97.97 0 01-.32.4.909.909 0 01-.4.18 1.22 1.22 0 01-.34.06c-.107 0-.227-.02-.36-.06a1.064 1.064 0 01-.4-.18 1.243 1.243 0 01-.32-.4c-.08-.187-.12-.42-.12-.7v-4.16c0-.28-.02-.573-.06-.88a2.28 2.28 0 00-.26-.82 1.67 1.67 0 00-.56-.62c-.227-.16-.533-.24-.92-.24s-.72.08-1 .24a2.12 2.12 0 00-.7.58c-.173.24-.307.52-.4.84-.093.307-.14.62-.14.94v4.12c0 .28-.047.513-.14.7a.97.97 0 01-.32.4.909.909 0 01-.4.18 1.22 1.22 0 01-.34.06c-.107 0-.227-.02-.36-.06a1.064 1.064 0 01-.4-.18 1.243 1.243 0 01-.32-.4c-.08-.187-.12-.42-.12-.7v-7.36z"
      />
    </svg>
  );
});
SvgAlphabetN.displayName = "SvgAlphabetN";
const MemoForwardRef = memo(SvgAlphabetN);
export default MemoForwardRef;
